// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Loader = require("../common/Components/Loader.bs.js");
let Scalars = require("../../scalars/Scalars.bs.js");
let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let AgentProfilePhoto = require("../common/Components/AgentProfilePhoto.bs.js");
let RelativeDateLabel = require("../common/Components/RelativeDateLabel.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let DashboardCardComponents__Tw = require("./DashboardCardComponents__Tw.bs.js");
let ChapterDashboardBroadcastMessages_query_graphql = require("../../__generated__/ChapterDashboardBroadcastMessages_query_graphql.bs.js");
let ChapterDashboardBroadcastMessages_message_graphql = require("../../__generated__/ChapterDashboardBroadcastMessages_message_graphql.bs.js");

let convertFragment = ChapterDashboardBroadcastMessages_message_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ChapterDashboardBroadcastMessages_message_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ChapterDashboardBroadcastMessages_message_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ChapterDashboardBroadcastMessages_message_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ChapterDashboardBroadcastMessages_message_graphql.node, convertFragment, fRef);
}

let MessageFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ChapterDashboard__BroadcastMessages$SingleItem(props) {
  let message = RescriptRelay_Fragment.useFragment(ChapterDashboardBroadcastMessages_message_graphql.node, convertFragment, props.message);
  return JsxRuntime.jsx(ButtonsV5.Link.make, {
    href: "/messages/" + message.id,
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(AgentProfilePhoto.make, {
            profilePhoto: message.agent.fragmentRefs
          }),
          className: "mr-2.5"
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("span", {
              children: message.category.name,
              className: "font-light text-gray-500 uppercase"
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                    children: message.subject,
                    className: "font-semibold text-gray-600 line-clamp-2"
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("span", {
                        children: message.agent.displayName + ` · `,
                        className: "text-gray-600"
                      }),
                      JsxRuntime.jsx(RelativeDateLabel.make, {
                        date: Scalars.DateTime.toUTC(message.broadcastAt)
                      })
                    ]
                  })
                ],
                className: "mr-1.25 flex-grow"
              }),
              className: "flex flex-row mb-1.25"
            })
          ],
          className: "flex flex-col"
        })
      ],
      className: "flex flex-row justify-start"
    })
  });
}

let SingleItem = {
  MessageFragment: MessageFragment,
  make: ChapterDashboard__BroadcastMessages$SingleItem
};

function ChapterDashboard__BroadcastMessages$LoadingState(props) {
  return JsxRuntime.jsx(DashboardCardComponents__Tw.LoadingStateContainer.make, {
    children: JsxRuntime.jsx(Loader.make, {})
  });
}

let LoadingState = {
  make: ChapterDashboard__BroadcastMessages$LoadingState
};

let convertFragment$1 = ChapterDashboardBroadcastMessages_query_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ChapterDashboardBroadcastMessages_query_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(ChapterDashboardBroadcastMessages_query_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ChapterDashboardBroadcastMessages_query_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(ChapterDashboardBroadcastMessages_query_graphql.node, convertFragment$1, fRef);
}

let QueryFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function ChapterDashboard__BroadcastMessages$EmptyState(props) {
  return JsxRuntime.jsx(DashboardCardComponents__Tw.EmptyStateContainer.make, {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("p", {
          children: "There are no broadcast messsages in your TAN chapter."
        }),
        JsxRuntime.jsx("p", {
          children: JsxRuntime.jsxs("span", {
            children: [
              JsxRuntime.jsx(ButtonsV5.Link.make, {
                href: "/messages/new",
                children: "Broadcast a message now"
              }),
              " to connect with other agents on industry discussion and other topics."
            ]
          })
        })
      ],
      className: "text-left space-y-7"
    })
  });
}

let EmptyState = {
  EmptyStateContainer: undefined,
  make: ChapterDashboard__BroadcastMessages$EmptyState
};

function ChapterDashboard__BroadcastMessages(props) {
  let query = RescriptRelay_Fragment.useFragment(ChapterDashboardBroadcastMessages_query_graphql.node, convertFragment$1, props.query);
  let match = query.messageBroadcasts;
  let messages;
  if (match !== undefined) {
    let edges = match.edges;
    messages = edges !== undefined ? Stdlib_Array.filterMap(edges, e => {
        if (e !== undefined) {
          return e.node;
        }
      }) : [];
  } else {
    messages = [];
  }
  if (messages.length !== 0) {
    return JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("ul", {
          children: messages.map(m => JsxRuntime.jsx("li", {
            children: JsxRuntime.jsx(ChapterDashboard__BroadcastMessages$SingleItem, {
              message: m.fragmentRefs
            }),
            className: "my-2"
          }, m.id)),
          className: "flex flex-col space-y-6"
        }),
        JsxRuntime.jsx(DashboardCardComponents__Tw.Footer.make, {
          href: "/messages",
          linkText: "Search all broadcast messages"
        })
      ],
      className: "space-y-8"
    });
  } else {
    return JsxRuntime.jsx(ChapterDashboard__BroadcastMessages$EmptyState, {});
  }
}

let DashboardCardComponents;

let make = ChapterDashboard__BroadcastMessages;

exports.DashboardCardComponents = DashboardCardComponents;
exports.SingleItem = SingleItem;
exports.LoadingState = LoadingState;
exports.QueryFragment = QueryFragment;
exports.EmptyState = EmptyState;
exports.make = make;
/* Loader Not a pure module */
